import { FormatType } from '@revelio/replots';

export const getTalentDiscoveryFormat = (columnKey: string): FormatType => {
  if (
    columnKey === 'Total Compensation' ||
    columnKey === 'Base Salary' ||
    columnKey === 'Min Salary' ||
    columnKey === 'Max Salary' ||
    columnKey === 'Salary'
  ) {
    return FormatType.CURRENCY;
  }

  if (columnKey === 'Years of Experience') {
    return FormatType.YEAR;
  }

  if (columnKey === 'Graduation Year') {
    return FormatType.CALENDAR_YEAR;
  }

  return FormatType.SI;
};
